module.exports = __webpack_public_path__ + "img/ZhixiangZhou.b0307750.jpg";